import { useState } from "react";
import styles from "./HistoryButton.module.scss";
import { IconType } from "../../icons/Icon";
import { IconButton } from "../button/iconButton/IconButton";
import { HistoryDialog } from "./HistoryDialog";
import { IHistoryConfig } from "./models/historyModels";

interface IHistoryButtonProps {
  entityId: number;
  entityCreatedOn: string;
  timezone?: string;
  label?: string;
  iconHeight?: string;
  iconWidth?: string;
  config: IHistoryConfig;
}

export const HistoryButton = ({
  entityId,
  entityCreatedOn,
  timezone,
  label = "История",
  iconHeight = "22px",
  iconWidth = "22px",
  config,
}: IHistoryButtonProps) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div className={styles.wrapper}>
        <IconButton
          iconType={IconType.ClockIcon}
          iconHeight={iconHeight}
          iconWidth={iconWidth}
          tooltip={label}
          onClick={() => setShowDialog(true)}
        />
      </div>
      <HistoryDialog
        entityId={entityId}
        entityCreatedOn={entityCreatedOn}
        timezone={timezone}
        showDialog={showDialog}
        onHide={() => setShowDialog(false)}
        label={label}
        config={config}
      />
    </>
  );
};
